// import CurrencyCodes from 'currency-codes'
// import CurrencyList from 'currency-list'
import { Currency } from '../models/currency.model'
import { currencies } from '../languages/translations/currencies';
import { formatCurrency } from '../scripts/format.value.script';

const codeEnMap: { [key: string]: Currency } = {}
const codeEsMap: { [key: string]: Currency } = {}
const codeFrMap: { [key: string]: Currency } = {}
const codeItMap: { [key: string]: Currency } = {}
const codeDeMap: { [key: string]: Currency } = {}

function mapCodeAndNameAndSymbol(currency: any): void {
  codeEnMap[currency.code.toLowerCase()] = { code: currency.code, name: currency.en, symbol: currency.symbol }
  codeEsMap[currency.code.toLowerCase()] = { code: currency.code, name: currency.es, symbol: currency.symbol }
  codeFrMap[currency.code.toLowerCase()] = { code: currency.code, name: currency.fr, symbol: currency.symbol }
  codeItMap[currency.code.toLowerCase()] = { code: currency.code, name: currency.it, symbol: currency.symbol }
  codeDeMap[currency.code.toLowerCase()] = { code: currency.code, name: currency.de, symbol: currency.symbol }
}

currencies.forEach(mapCodeAndNameAndSymbol)

export function currencyList(code_language: string): Currency[] {
  let key = code_language.toLowerCase() as 'en' | 'es' | 'fr' | 'it' | 'de'
  return currencies.map((item) => ({code: item.code, name: item[key] || item.en, symbol: item.symbol}))
}

export function currencyObject(code_language: string, code: string): Currency {
  let key = code_language.toLowerCase() as 'en' | 'es' | 'fr' | 'it' | 'de'
  return (key === 'es' ? codeEsMap : key === 'fr' ? codeFrMap : key === 'it' ? codeItMap : key === 'de' ? codeDeMap : codeEnMap)[code.toLowerCase()]
}

export function currencyValue(code_language: string, code: string): string {
  return formatCurrency(currencyObject(code_language, code))
}

export function currencyAll(): Currency[] {
  let currencies: Currency[] = []

  /* for (let code of CurrencyCodes.codes()) {
    if (CurrencyList.get(code)) {
      currencies.push({code: CurrencyList.get(code).code, name: CurrencyList.get(code).name, symbol: CurrencyList.get(code).symbol})
    }
  } */

  return currencies
}